//#region Module
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Card, CardContent, Typography, Box, Grid, CardHeader, IconButton, CardActionArea } from '@mui/material'
import CardMedia from '@mui/material/CardMedia'
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/icon-delete.svg"
import FolderPlaceholder from "../../../assets/img/FolderPlaceholder.png"
import { ReactComponent as EditIcon } from "../../../assets/icons/icon_edit.svg";
import { makeStyles } from '@mui/styles'

import { FolderCardTitleLength, FolderCardDescriptionLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";
//#endregion


const useStyles = makeStyles((theme) => ({
    actionArea: {
        "&:hover $focusHighlight": {
          opacity: 0
        }
      },
      focusHighlight: {}

}));

export default function ReportCard({ folder, handleDeleteReport, handleAddFolderPopup }) {
    const { folderName, _id, folderDescription } = folder
    const classes = useStyles();
    
    return (
        <Card className="report-card">
            <CardActionArea className="report-card-action" component={Link}  to={`/report/report-folder-view/${_id}?folderName=${folderName}`}
                classes={{
                    root: classes.actionArea,
                    focusHighlight: classes.focusHighlight
                  }}>
                <CardContent className="cm-card-content">
                    <CardMedia className="cm-dash-image" image={FolderPlaceholder} title={folderName} />
                </CardContent>
            </CardActionArea>

            <CardContent className='report-card-footer'>
                <Typography variant="h6" className='folder-card-title'>
                    <Link className="blk_icon " title={folderName} to={`/report/report-folder-view/${_id}?folderName=${folderName}`}> {handleStringLength(folderName, FolderCardTitleLength)}</Link>
                </Typography>
                <Typography variant="subtitle2" gutterBottom className='text-plain font-weight-normal' title={folderDescription} 
                    >{handleStringLength(folderDescription, FolderCardDescriptionLength) || 'No description'}</Typography>

                <Grid container direction="row" alignItems="center" justifyContent='flex-start' wrap="wrap">
                    <Grid item xl={3} lg={4} md={4} xs={4} justifyContent='flex-start'>
                        <Box display='flex' alignItems='center' my={1}>
                            <IconButton disableRipple={true} onClick={() => handleAddFolderPopup('Edit', folder)} className="report-card-footer-icon report-card-delete-icon no-hover" >
                                <SvgIcon component={EditIcon} color="primary" className="card_btn_action_icon" />
                                <Typography ml={1}>Edit</Typography>
                            </IconButton>
                        </Box>
                    </Grid>

                    <Grid item xl={3} lg={4} md={4} xs={4} >
                        <Box display='flex' alignItems='center'>
                            <IconButton disableRipple={true} onClick={() => handleDeleteReport(folder)} className="report-card-footer-icon report-card-delete-icon no-hover" >
                                <SvgIcon component={DeleteIcon} color="primary" className="card_btn_action_icon" />
                                <Typography ml={1}> Delete</Typography>
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

ReportCard.propTypes = {
    report: PropTypes.object,
}
